// extracted by mini-css-extract-plugin
export default {"linkStyleCopy":"a7-z"};